import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@account-environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  ApiConfigsGetRequest,
  ApiConfigsGetResponse,
  ApiConfigsUpdateRequest,
  ApiConfigsUpdateResponse,
  ApiConfig
} from '@iw-shared/api/configs';
import {setProductDB} from "@account/store/actions/config.action";
import {setBackendIdentifier} from "@iw-shared/store/actions/global.actions";
import {AppState} from "@iw-shared/store/state/app.state";
import {Store} from "@ngrx/store";
import {finalize} from "rxjs/operators";
import {ApiDynamicArticlesUpdateRequest} from "@account/shared/api/api-dynamic-article";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private http: HttpClient, private store: Store<AppState>) {

  }

  getConfig(type: string = 'live'): Observable<ApiConfigsGetResponse> {
    const body: ApiConfigsGetRequest = {
      id: 'getConfig',
      command: 'configs/get',
      params: {
        filters: [{
          fields: ['type'],
          values: [type]
        }],
        configs: {}
      }
    };
    return this.http.post<ApiConfigsGetResponse>(environment.urlApi, JSON.stringify(body));
  }

  updateConfig(data: ApiConfigsUpdateRequest['params']['data'], unset?: ApiConfigsUpdateRequest['params']['unset']): Observable<ApiConfigsUpdateResponse> {
    const body: ApiConfigsUpdateRequest = {
      id: 'updateConfig#INVALID_PARAMS',
      command: 'configs/update',
      params: {
        data,
        unset
      }
    };
    return this.http.post<ApiConfigsUpdateResponse>(environment.urlApi, JSON.stringify(body)).pipe(finalize(() => this.setConfigStateFromDB()));
  }

  setConfigStateFromDB(){
    this.getConfig().subscribe(r => {
      if (r.result?.configs.data[0]) {
        this.store.dispatch(setProductDB({productDBToken: r.result?.configs.data[0].productDBToken, productDBCopyFields: r.result?.configs.data[0].productDBCopyFields}))
        this.store.dispatch(setBackendIdentifier({backendIdentifier: r.result?.configs.data[0].shopUrl}))
      }
    })
  }
}
